<script setup lang="ts">
const { orientation } = useCarousel();
</script>

<template>
  <div
    class="carousel-item"
    :class="{
      'carousel-item--horizontal': orientation === 'horizontal',
      'carousel-item--vertical': orientation === 'vertical',
    }"
    role="group"
    aria-roledescription="slide">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.carousel-item {
  min-width: 0;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 100%;

  &--horizontal {
    padding-left: 1rem;
  }

  &--vertical {
    padding-top: 1rem;
  }
}

.hydrated .carousel-item {
  display: flex !important;
}
</style>
